import React from "react";
import { Button, Card, Form } from "react-bootstrap";
import clickSimCard from "../../assets/img/sim.png";
import { FaCartPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  addToBasket,
  removeFromBasket,
  updateBasketQuantity,
} from "../../redux/slices/purchaseOrders";

const PurchaseOrderProduct = ({ product }) => {
  const dispatch = useDispatch();
  const billingPreferences = useSelector(
    (state) => state.preferences.billingPreferences
  );
  const simCardPrice = billingPreferences?.simCardPrice ?? 0;
  const simChipPrice = billingPreferences?.simChipPrice ?? 0;
  const basketItem = useSelector((state) =>
    state.purchaseOrders.basket.find(
      (b) =>
        b.catalogueSimProductId.catalogueId ===
          product.catalogueSimProductId.catalogueId &&
        b.catalogueSimProductId.simProductId ===
          product.catalogueSimProductId.simProductId
    )
  );

  const priceMap = {
    "IoT SIM Card": simCardPrice,
    "IoT SIM Chip": simChipPrice,
    // You can easily add new mappings here in the future:
    // "IoT eSIM": simESimPrice,
  };

  const productDescription = product.simProduct?.description;
  const selectedPrice = priceMap[productDescription] ?? 0;

  const handleAddToBasket = () => {
    dispatch(
      addToBasket({
        ...product,
        quantity: 1,
        price: selectedPrice.toFixed(2),
      })
    );
  };

  const handleIncrease = () => {
    dispatch(
      updateBasketQuantity({
        id: product.catalogueSimProductId,
        quantity: basketItem.quantity + 1,
      })
    );
  };

  const handleDecrease = () => {
    if (basketItem.quantity === 1) {
      dispatch(removeFromBasket(product.catalogueSimProductId));
    } else {
      dispatch(
        updateBasketQuantity({
          id: product.catalogueSimProductId,
          quantity: basketItem.quantity - 1,
        })
      );
    }
  };
  return (
    <Card
      style={{
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
      }}
    >
      <Card.Img
        src={clickSimCard}
        style={{
          height: "auto",
          objectFit: "cover",
          borderBottomLeftRadius: "0",
          borderBottomRightRadius: "0",
          borderTopRightRadius: "20px",
          borderTopLeftRadius: "20px",
        }}
      />
      <Card.Body
        style={{
          backgroundColor: "#042742",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        <Card.Title style={{ color: "#fff" }}>
          {product.simProduct.description}
        </Card.Title>
        <div className="main-product-container">
          <p
            style={{
              fontSize: "18px",
              lineHeight: "23px",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            €
            {product.simProduct.description === "IoT SIM Card"
              ? simCardPrice.toFixed(2)
              : product.simProduct.description === "IoT SIM Chip"
              ? simChipPrice.toFixed(2)
              : "0.00"}
          </p>
        </div>
        <div className="d-flex justify-content-center">
          {!basketItem ? (
            <Button
              style={{
                "--dynamic-bg-color": "#04addc",
                "--dynamic-font-color": "#fff",
                border: "none",
                padding: "10px 15px",
              }}
              onClick={handleAddToBasket}
            >
              <FaCartPlus size={18} className="me-2" />
              Add to Basket
            </Button>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <Button variant="outline-light" onClick={handleDecrease}>
                -
              </Button>
              {/* <span
                style={{
                  color: "#fff",
                  fontSize: "18px",
                  minWidth: "32px",
                  textAlign: "center",
                }}
              >
                {basketItem.quantity}
              </span> */}
              <Form.Control
                type="text"
                className="text-center"
                value={basketItem.quantity}
                onKeyDown={(e) => {
                  // Prevent letters and invalid symbols
                  if (
                    ["e", "E", "+", "-", "."].includes(e.key) || // disallow exponent, plus, minus, dot
                    (isNaN(parseInt(e.key)) &&
                      e.key !== "Backspace" &&
                      e.key !== "Delete" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight")
                  ) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (isNaN(value)) return;

                  if (value <= 0) {
                    dispatch(removeFromBasket(product.catalogueSimProductId));
                  } else {
                    dispatch(
                      updateBasketQuantity({
                        id: product.catalogueSimProductId,
                        quantity: value,
                      })
                    );
                  }
                }}
                style={{
                  fontSize: "18px",
                }}
              />
              <Button variant="outline-light" onClick={handleIncrease}>
                +
              </Button>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default PurchaseOrderProduct;
